import React, { useState, useEffect, useContext } from "react";

import Footer from "../../molecules/footer/footer";
import Header from "../../molecules/header/header";
import HeadboardBooks from "../headboard-books/headboardBooks";
import HeadboardMap from "../headboard-map/headboardMap";
import HeadboardButtons from "../headboard-buttons/headboardButtons";
import HeadboardTabs from "../headboard-tabs/headboardTabs";
import HeadboardService from "../headboard-service/headboardService";
import HeadboardClub from "../headboard-club/headboardClub";
import HeadboardPodcast from '../headboardPodcast/headboardPodcast';
import HeadboardConversation from '../headboard-conversation/headboardConversation';
import Heaboard from '../headboard/headboard';
import Nav from "../nav/nav";

import GlobalContext from "../../../contexts/globalContext";

import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";

import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useChangeTheme from "../../../shared/hooks/useChangeTheme";
import useDirectionScroll from "../../../shared/hooks/useDirectionScroll";

import "./layout.scss";
import HeadboardClubDetail from "../headboard-club-detail/headboardClubDetail";
import PodcastDetail from "../podcast-detail/podcastDetail";
import HeadboardVideo from '../headboard-video/headboardVideo'
import BookDetailManual from '../book-detail-manual/bookDetailManual'
import SimpleHeadboard from "../simple-headboard/simpleHeadboard";
import { setCollectionToken } from "../../../services/token";

interface LayoutInterface {
  children: any;
  headboard?: ReferenciaCabecera;
  isNotRoot?: boolean;
  hideHeaderDesktop: boolean;
  hideHeaderMobile: boolean;
}

const Layout = (props: LayoutInterface) => {
  const [isMenuActive, setMenuActive] = useState(false);
  const [isSearcherActive, setSearcherActive] = useState(false);
  const [_scrollActive, setScrollActive] = useState(false);
  const [isDark, changeDarkMode] = useChangeTheme();
  const { lastDirection, resetDirection } = useDirectionScroll();
  const { isBrowser, localStorage, document, window } = useBrowserMode();
  const {superFooter, fontSize} = useContext(GlobalContext);
  useEffect(() => {
    toLocalStoragepageActive();
    if (isBrowser) {
      const realSize = parseInt(localStorage.getItem("font-size") || "100");
      const item = document.querySelector("html") || {
        style: { fontSize: realSize },
      };
      item.style.fontSize = `${realSize}%`;
      fontSize?.set(realSize);
      setCollectionToken(localStorage.getItem("uid") || "", true, true);
      toLocalStoragepageActive();
    }
    isBrowser && document.addEventListener("scroll", onScrollAction);
    return () => {
      isBrowser && document.removeEventListener("scroll", onScrollAction);
    };
  }, []);

  const toLocalStoragepageActive = () => {
    if (localStorage.getItem("Redirection")) {
      const data = JSON.parse(localStorage.getItem("Redirection"));
      if (data.titleButton === "BIBLIOTECAS") {
        return false;
      } else {
        return localStorage.setItem(
          "Redirection",
          JSON.stringify({
            titleButton: "BIBLIOTECAS",
            path: "bibliotecas",
          })
        );
      }
    } else {
      return localStorage.setItem(
        "Redirection",
        JSON.stringify({
          titleButton: "BIBLIOTECAS",
          path: "bibliotecas",
        })
      );
    }
  };

  const scrollActive = { get: _scrollActive, set: setScrollActive };

  let timerScroll: any;

  const onScrollAction = () => {
    window.clearTimeout(timerScroll);
    timerScroll = setTimeout(() => {
      if (window.pageYOffset < 70) {
        resetDirection();
      }
    }, 66);
  };

  const switchHeadBoard = (headboard: ReferenciaCabecera, superFooter) => {
    switch (headboard[0].tipoCabecera) {
      case "CabeceraRotador":
        return <HeadboardBooks {...headboard} />;
      case "CabeceraTabs":
        return <HeadboardTabs superFooter={superFooter} {...headboard} />;
      case "CabeceraBotones":
        return <HeadboardButtons superFooter={superFooter} {...headboard} />;
      case "CabeceraDistribuidora":
        return <HeadboardService {...headboard} />;
      case "CabeceraClubes":
        return <HeadboardClub {...headboard} />;
      case "DetalleClubes":
        return <HeadboardClubDetail {...headboard} />;
      case "Podcast":
        return <HeadboardPodcast {...headboard} />;
      case "DetallePodcast":
        return <PodcastDetail {...headboard} />;
      case "Episodio":
        return <PodcastDetail {...headboard} />;
      case "DetalleVideo":
        return <HeadboardVideo {...headboard} />;
      case "DetalleLibro":
        return <BookDetailManual cabecera={headboard} />
      case "CabeceraSimple":
        return <SimpleHeadboard {...headboard} />;
      case 'CabeceraConversacion':
        return <HeadboardConversation {...headboard} />;
      case 'CabeceraDirectorio':
        return  <Heaboard {...headboard}/>
      case 'CabeceraMapa':
        return  <HeadboardMap {...headboard}/> 
      default:
        return <SimpleHeadboard superFooter={superFooter} {...headboard} />;
    }
  };

  return (
    <>
      <Header
        isNotRoot={props.isNotRoot}
        scrollActive={scrollActive}
        isMenuActive={isMenuActive}
        isSearcherActive={isSearcherActive}
        setMenuActive={setMenuActive}
        setSearcherActive={setSearcherActive}
        isDark={isDark}
        actionTheme={changeDarkMode}
        lastDirection={lastDirection}
        hideHeaderDesktop={props.hideHeaderDesktop}
        hideHeaderMobile={props.hideHeaderMobile}
      />
      <Nav
        isMenuActive={isMenuActive}
        isSearcherActive={isSearcherActive}
        isDark={isDark}
        actionTheme={changeDarkMode}
      />
      <div>
        {props.headboard &&
          switchHeadBoard(props.headboard, superFooter)}
        <main>{props.children}</main>
      </div>
      <Footer isSuperFooter={superFooter.get} />
    </>
  );
};

export default Layout;
